import script from "./ErrorMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorMessage.vue?vue&type=style&index=0&id=4481f988&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4481f988"]])

export default __exports__